import { useQuery } from '@tanstack/react-query';
import vlqrApi from 'utils/vlqrApi';

const getActivityRecordings = async (activityId) => {
    const { data } = await vlqrApi.get(`Reports/${activityId}/Recordings`);
    return data;
};

const useActivityRecordings = (activityId) => {
    const { data, refetch, isLoading } = useQuery({
        queryKey: ['activityRecordings', activityId],
        queryFn: () => getActivityRecordings(activityId)
    });

    return { data, refetch, isLoading };
};

export default useActivityRecordings;
